export interface ReeferMonitoringFormProfile {
  id?: number
  cargoUnitJourneyId: number | null
  isPluggedIn: boolean
  temperature?: number | string | null
  humidity?: number | string | null
  ventilation?: number | string | null
  recordedAt: Date
  additionalInfo?: string
  isTemperatureRequired?: boolean
}

export const defaultValues: ReeferMonitoringFormProfile = {
  cargoUnitJourneyId: null,
  isPluggedIn: false,
  temperature: '',
  humidity: '',
  ventilation: '',
  recordedAt: new Date(),
  isTemperatureRequired: false,
}
